<template>
    <main :class="[isLight ? 'lightmode' : 'darkmode']">
        <h1>Calendar Converter</h1>
        <form @submit.prevent="calculate" :class="[isLight ? 'lightmode' : 'darkmode']">
            <div id="selects">
                <div class="input-divs">
                    <label for="from-select">From</label>
                    <select v-model="fromIndex" id="from-select" :class="[isLight ? 'lightmode' : 'darkmode']" @change="resetMonthAndDate">
                        <option value="0">Gregorian</option>
                        <option value="1">Islamic</option>
                        <option value="2">Persian</option>
                        <option value="3">Hebrew</option>
                    </select>
                </div>
                <div class="input-divs">
                    <label for="to-select">To</label>
                    <select v-model="toIndex" id="to-select" :class="[isLight ? 'lightmode' : 'darkmode']">
                        <option value="0">Gregorian</option>
                        <option value="1">Islamic</option>
                        <option value="2">Persian</option>
                        <option value="3">Hebrew</option>
                    </select>
                </div>
            </div>
            <div id="inputs">
                <div class="input-divs">
                    <label for="freeform-input">{{ calendars[fromIndex].freeformInput }}</label>
                    <input type="number" id="freeform-input" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="currentYear"/>
                </div>
                <div class="input-divs">
                    <label for="month-input">{{ calendars[fromIndex].inputs[0] }}</label>
                    <select v-if="!calendars[fromIndex].leap(currentYear)" id="month-input" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="currentMonth">
                        <option v-for="(month,index) in calendars[fromIndex].regularMonths" :key="month.name" :value="index">{{ month.name }}</option>
                    </select>
                    <select v-if="calendars[fromIndex].leap(currentYear)" id="month-input" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="currentMonth">
                        <option v-for="(month,index) in calendars[fromIndex].leapMonths" :key="month.name" :value="index">{{ month.name }}</option>
                    </select>
                </div>
                <div class="input-divs">
                    <label for="day-input">{{ calendars[fromIndex].inputs[1] }}</label>
                    <select v-if="!calendars[fromIndex].leap(currentYear)" id="day-input" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="currentDay">
                        <option v-for="day in calendars[fromIndex].regularMonths[currentMonth].days" :key="day" :value="day">{{ day }}</option>
                    </select>
                    <select v-if="calendars[fromIndex].leap(currentYear)" id="day-input" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="currentDay">
                        <option v-for="day in calendars[fromIndex].leapMonths[currentMonth].days" :key="day" :value="day">{{ day }}</option>
                    </select>
                </div>
            </div>
            <button type="submit" :class="[isLight ? 'lightmode' : 'darkmode']">Convert</button>
            <fieldset>
                <legend>Result</legend>
                <output :class="[formSubmitted ? '' : 'not-submitted',isLight ? 'lightmode' : 'darkmode']">{{ resultlbl }}</output>
            </fieldset>
        </form>
    </main>
</template>

<script setup>
    import { ref,defineProps,toRef } from 'vue';

    import hijrahDate from 'hijrah-date';
    import { toJewishDate,toGregorianDate,isLeapYear } from 'jewish-date';
    var jalaali = require('jalaali-js');

    const props = defineProps({
        darkMode:Boolean
    });

    var isLight = toRef(props,'darkMode');

    var fromIndex = ref("0");
    var toIndex = ref("1");

    var currentYear = ref(new Date().getFullYear());
    var currentMonth = ref(new Date().getMonth());
    var currentDay = ref(new Date().getDate());

    var resultlbl = ref("Result");
    var formSubmitted = ref(false);

    const calendars = ref([
        {
            name:'Gregorian',
            freeformInput:'Year',
            inputs:['Month','Day','Hour','Minute','Second'],
            leap:(year) => (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0),
            cycles:false,
            regularMonths:[
                {
                    name:'January',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'February',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28]
                },
                {
                    name:'March',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'April',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'May',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'June',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'July',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'August',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'September',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'October',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'November',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'December',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                }
            ],
            leapMonths:[
                {
                    name:'January',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'February',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'March',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'April',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'May',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'June',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'July',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'August',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'September',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'October',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'November',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'December',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                }
            ]
        },
        {
            name:'Islamic',
            freeformInput:'Year',
            inputs:['Month','Day','Hour','Minute','Second'],
            leap:(year) => 
            {
                const leapYearsInCycle = [2, 5, 7, 10, 13, 16, 18, 21, 24, 26, 29];
                return leapYearsInCycle.includes(year % 30);
            },
            cycles:false,
            regularMonths:[
                {
                    name:'Muharram',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Safar',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"R. al-Awwal",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"R. al-Thani",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'J. al-Awwal',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'J. al-Thani',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Rajab',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"Sha'ban",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Ramadan',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Shawwal',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"D. al-Qa'dah",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'D. al-Hijjah',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                }
            ],
            leapMonths:[
            {
                    name:'Muharram',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Safar',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"R. al-Awwal",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"R. al-Thani",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'J. al-Awwal',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'J. al-Thani',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Rajab',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"Sha'ban",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Ramadan',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Shawwal',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"D. al-Qa'dah",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'D. al-Hijjah',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                }
            ]
        },
        {
            name:'Persian',
            freeformInput:'Year',
            inputs:['Month','Day','Hour','Minute','Second'],
            leap:(year) => jalaali.isLeapJalaaliYear(year),
            cycles:false,
            regularMonths:[
                {
                    name:'Farvardin',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Ordibehesht',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Khordad',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Tir',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Mordad',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Shahrivar',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Mehr',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"Aban",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Azar',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Dey',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Bahman',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Esfand',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                }
            ],
            leapMonths:[
            {
                    name:'Farvardin',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Ordibehesht',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Khordad',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Tir',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Mordad',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Shahrivar',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
                },
                {
                    name:'Mehr',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"Aban",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Azar',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Dey',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Bahman',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Esfand',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                }
            ]
        },
        {
            name:'Hebrew',
            freeformInput:'Year',
            inputs:['Month','Day','Hour','Minute','Second'],
            leap:(year) => isLeapYear(year),
            cycles:false,
            regularMonths:[
                {
                    name:'Tishri',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"Cheshvan",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Kislev',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Tevet',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Shevat',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Adar',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Nisan',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Iyyar',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Sivan',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Tammuz',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Av',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Elul',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                }
            ],
            leapMonths:[
                {
                    name:'Tishri',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:"Cheshvan",
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Kislev',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Tevet',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Shevat',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'AdarI',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'AdarII',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Nisan',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Iyyar',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Sivan',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Tammuz',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                },
                {
                    name:'Av',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                },
                {
                    name:'Elul',
                    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
                }
            ]
        }
    ]);

    const resetMonthAndDate = () =>
    {
        currentDay.value = 1;
        currentMonth.value = 0;
    }

    const calculate = () =>
    {
        formSubmitted.value = true;

        var startDay,startMonth,StartYear,endDay,endMonth,endYear,isValid = true;

        switch(fromIndex.value)
        {
            case "0":
            {
                startDay = currentDay.value;
                startMonth = currentMonth.value;
                StartYear = currentYear.value;
                break;
            }

            case "1":
            {
                try
                {
                    var islamicDate = new hijrahDate(currentYear.value,currentMonth.value,currentDay.value).toGregorian();
                    startDay = islamicDate.getDate();
                    startMonth = islamicDate.getMonth();
                    StartYear = islamicDate.getFullYear();
                }
                catch(e)
                {
                    isValid = false;
                }
                
                break;
            }

            case "2":
            {
                try
                {
                    var persianDate = jalaali.toGregorian(currentYear.value,currentMonth.value+1,currentDay.value);
                    startDay = persianDate.gd;
                    startMonth = persianDate.gm-1;
                    StartYear = persianDate.gy;
                }
                catch(e)
                {
                    isValid = false;
                }
                
                break;
            }

            case "3":
            {
                try
                {
                    var hebrewDate = toGregorianDate({year:currentYear.value,monthName:calendars.value[3].leap(currentYear.value) ? calendars.value[3].leapMonths[currentMonth.value].name : calendars.value[3].regularMonths[currentMonth.value].name,day:currentDay.value});
                    startDay = hebrewDate.getDate();
                    startMonth = hebrewDate.getMonth();
                    StartYear = hebrewDate.getFullYear();
                }
                catch(e)
                {
                    isValid = false;
                }
                    
                break;
            }
        }

        if(isValid)
        {
            switch(toIndex.value)
            {
                case "0":
                {
                    endDay = startDay;
                    endMonth = startMonth;
                    endYear = StartYear;
                    resultlbl.value = endDay + " " + (calendars.value[0].leap(endYear) ? calendars.value[0].leapMonths[endMonth].name : calendars.value[0].regularMonths[endMonth].name) + " " + endYear;
                    break;
                }

                case "1":
                {
                    var islamDate = new hijrahDate(new Date(StartYear,startMonth,startDay));
                    endDay = islamDate.getDate();
                    endMonth = islamDate.getMonth();
                    endYear = islamDate.getFullYear();
                    resultlbl.value = endDay + " " + (calendars.value[1].leap(endYear) ? calendars.value[1].leapMonths[endMonth].name : calendars.value[1].regularMonths[endMonth].name) + " " + endYear;
                    break;
                }

                case "2":
                {
                    var iranianDate = jalaali.toJalaali(new Date(StartYear,startMonth,startDay));
                    endDay = iranianDate.jd;
                    endMonth = iranianDate.jm-1;
                    endYear = iranianDate.jy;
                    resultlbl.value = endDay + " " + (calendars.value[2].leap(endYear) ? calendars.value[2].leapMonths[endMonth].name : calendars.value[2].regularMonths[endMonth].name) + " " + endYear;
                    break;
                }

                case "3":
                {
                    var jewDate = toJewishDate(new Date(StartYear,startMonth,startDay));
                    endDay = jewDate.day;
                    endMonth = jewDate.month-1;
                    endYear = jewDate.year;
                    resultlbl.value = endDay + " " + (calendars.value[3].leap(endYear) ? calendars.value[3].leapMonths[endMonth].name : calendars.value[3].regularMonths[endMonth].name) + " " + endYear;
                    break;
                }
            }
        }
        
        else
        {
            resultlbl.value = "That date is not accepted";
        }
    }
</script>

<style scoped>
    main
    {
        grid-area: 2 / 1 / 3 / 2;
        font-family: Syne;
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width:92%;
        height:fit-content;
        max-width: 600px;
        padding:1.75% 0;
        margin:24px auto;
        border-radius: 12px;
    }

    main.lightmode
    {
        background-color: #F7F7F6;
        color:#2b3133;
        box-shadow:#2b3133 0px 1px 7px 1px;
        -webkit-box-shadow:#2b3133 0px 1px 7px 1px;
    }

    main.darkmode
    {
        background-color: #2b3133;
        color: #F7F7F6;
        box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
        -webkit-box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
    }

    form
    {
        display:flex;
        flex-direction: column;
        align-items: center;
    }

    form.lightmode,main.lightmode
    {
        color:#2b3133;
    }

    form.darkmode,main.darkmode
    {
        color:#F7F7F6;
    }

    h1
    {
        margin: 0;
        cursor:default;
        font-size: x-large;
    }
    
    div#selects,div#inputs
    {
        display:flex;
        flex-direction: row;
        width:90vw;
        justify-content: space-between;
        height:80px;
        margin-bottom: 10px;
    }

    div.input-divs
    {
        display:flex;
        flex-direction: column;
        height:100%;
    }

    div.input-divs > select,div.input-divs > input
    {
        flex-grow: 1;
    }

    div#selects > div.input-divs
    {
        width:45%;
    }

    div#inputs > div.input-divs
    {
        width:28%;
    }

    label
    {
        font-size: 30px;
    }

    select,input
    {
        font-size: 20px;
        text-indent: 6px;
        border-radius: 20px;
        border:1px solid #2b3133;
    }

    select
    {
        cursor:pointer;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button
    {
        appearance: none;
        -webkit-appearance: none;
    }

    input:focus,select:focus
    {
        outline: none;
    }

    select
    {
        appearance:none;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-overflow: ellipsis;
    }

    select.lightmode,input.lightmode
    {
        background-color: #F7F7F6;
        color:#2b3133;
    }

    select.darkmode,input.darkmode
    {
        background-color: #202526;
        color:#F7F7F6;
    }

    button
    {
        grid-area: 5 / 1 / 6 / -1;
        justify-self: center;
        align-self: center;
        font-family: Syne;
        font-size: xx-large;
        padding:12px;
        border:none;
        border-radius: 20px;
        margin-top: 5px;
        margin-bottom: 6px;
        cursor: pointer;
    }

    button.lightmode
    {
        background-color: #1DCD9F;
        color:#F7F7F6;
    }

    button.darkmode
    {
        background-color: #328E6E;
        color:#F7F7F6;
    }

    button:hover
    {
        text-decoration: underline;
    }

    fieldset
    {
        height:100px;
        border-radius: 8px;
        width:90%;
        height:fit-content;
    }

    output
    {
        font-size: 40px;
        justify-self: center;
        padding:6px;
        word-break: break-word;
        overflow-wrap: anywhere;
    }

    output.not-submitted.lightmode,output.darkmode
    {
        color:#F7F7F6;
    }

    output.not-submitted.darkmode,output.lightmode
    {
        color:#2b3133;
    }

    @media (max-width:250px)
    {
        h1,label
        {
            font-size: medium;
        }

        input,select
        {
            text-indent: 4px;
            font-size: 16px;
        }

        fieldset
        {
            width:80%;
        }
    }

    @media (min-width:500px)
    {
        form
        {
            width:500px;
            justify-self: center;
        }

        div#selects,div#inputs
        {
            width:450px;
        }
    }
</style>